import { People } from '@mui/icons-material';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { GroupMessageSmsStatusGrid } from './groupMessageSmsStatusGrid';
import { GroupMessageSmsResponse } from '../models/groupMessageSmsRespons';
import { GroupMessageSmsStatusSearchFilter } from '../models/groupMessageSmsStatusSearchFilter';

type GroupMessageSmsStatusModalProps = {
  modalOpen: boolean;
  groupMessageSmsResponse: GroupMessageSmsResponse;
  onSave: () => void;
  onClose: () => void;
};

export const GroupMessageSmsStatusModal = (props: GroupMessageSmsStatusModalProps) => {
  const { modalOpen, groupMessageSmsResponse, onSave, onClose } = props;
  const { t } = useTranslation(['common', 'groupMessage']);

  const onHandleSave = useCallback(() => {
    onSave();
  }, [onSave]);

  const onHandleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <GenericDialog
      open={modalOpen}
      padding={0}
      dialogTitle={t('groupMessage:sms.deliveryStatus')}
      dialogSubTitle={
        <Typography variant='body2' sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 500 }}>
          <span>{groupMessageSmsResponse.name}</span>
          <People fontSize='small' sx={{ fontSize: '1rem' }} />
          <span>{groupMessageSmsResponse.selectionName || groupMessageSmsResponse.speedFormText}</span>
        </Typography>
      }
      onClose={onHandleClose}
      onSave={onHandleSave}
      dialogContent={
        <Box className='section-inset' sx={{ p: 2 }}>
          <GridWrapper>
            <Grid item xs={12}>
              {groupMessageSmsResponse && groupMessageSmsResponse.batchList.length > 0 && (
                <GroupMessageSmsStatusGrid
                  loadingCallback={() => ConsoleHelper.log('X')}
                  searchFilter={{ filter: '', smsBatchId: groupMessageSmsResponse.batchList[0].id } as unknown as GroupMessageSmsStatusSearchFilter}
                />
              )}
            </Grid>
          </GridWrapper>
        </Box>
      }
      dialogActions={
        <Button variant='outlined' disableElevation onClick={onHandleClose}>
          {t('common:button.cancel')}
        </Button>
      }
    />
  );
};
